export default function tail() {
	const tail = this.$refs.tail;
	const root = this.$root;
	return {
		showTail: false,
		x: 0,
		y: 0,
		init() {
			root.onmousemove = (e) => {
				this.reCalcTail(e);
			};
			root.onmouseenter = (e) => {
				this.showTail = true;
			};
			root.onmouseleave = (e) => {
				this.showTail = false;
			};
			window.addEventListener("scroll", () => {
				this.scollTriggeredEvents();
			});
		},
		scollTriggeredEvents() {
			// check if the user has moved the mouse
			if (this.x == 0 && this.y == 0) return;

			// get hovered elements with data-title attribute
			let hoveredEls = document
				.elementsFromPoint(this.x, this.y)
				.filter((el) => el === root);

			// if no element is hovered, hide the tail
			if (hoveredEls.length === 0) {
				this.showTail = false;
				return;
			}

			// show the tail and set the text if an element with data-title is hovered
			hoveredEls.forEach(() => {
				this.showTail = true;
			});
		},
		reCalcTail(e) {
			tail.style.left = e.clientX + "px";
			tail.style.top = e.clientY + "px";
			this.x = e.clientX;
			this.y = e.clientY;
		},
	};
}
